var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 688,
    height: 520,
    viewBox: "0 0 688 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M375.181 252.362H258.374V510.755H375.181V252.362Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M353.947 252.362H258.374V510.755H353.947V252.362Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M376.557 252.362H255.855V256.574H376.557V252.362Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M376.557 243.924H255.855V248.135H376.557V243.924Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M374.025 248.136H258.374V252.347H374.025V248.136Z",
    fill: "#F0F0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M285.387 267.571H267.442V287.912H285.387V267.571Z",
    fill: "#E6E6E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M285.388 267.571H269.025V287.912H285.388V267.571Z",
    fill: "#F5F5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M312.581 267.571H294.636V287.912H312.581V267.571Z",
    fill: "#E6E6E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M312.58 267.571H296.218V287.912H312.58V267.571Z",
    fill: "#F5F5F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M339.759 267.571H321.814V287.912H339.759V267.571Z",
    fill: "#E6E6E6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M339.759 267.571H323.396V287.912H339.759V267.571Z",
    fill: "#F5F5F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M285.387 297.537H267.442V317.878H285.387V297.537Z",
    fill: "#E6E6E6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M285.388 297.537H269.025V317.878H285.388V297.537Z",
    fill: "#F5F5F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M312.581 297.537H294.636V317.878H312.581V297.537Z",
    fill: "#E6E6E6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M312.58 297.537H296.218V317.878H312.58V297.537Z",
    fill: "#F5F5F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M339.759 297.537H321.814V317.878H339.759V297.537Z",
    fill: "#E6E6E6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M339.759 297.537H323.396V317.878H339.759V297.537Z",
    fill: "#F5F5F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M285.387 352.397H267.442V372.738H285.387V352.397Z",
    fill: "#E6E6E6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M285.388 352.397H269.025V372.738H285.388V352.397Z",
    fill: "#F5F5F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M312.581 352.397H294.636V372.738H312.581V352.397Z",
    fill: "#E6E6E6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M312.58 352.397H296.218V372.738H312.58V352.397Z",
    fill: "#F5F5F5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M339.759 352.397H321.814V372.738H339.759V352.397Z",
    fill: "#E6E6E6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M339.759 352.397H323.396V372.738H339.759V352.397Z",
    fill: "#F5F5F5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M285.387 382.362H267.442V402.703H285.387V382.362Z",
    fill: "#E6E6E6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M285.388 382.362H269.025V402.703H285.388V382.362Z",
    fill: "#F5F5F5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M312.581 382.362H294.636V402.703H312.581V382.362Z",
    fill: "#E6E6E6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M312.58 382.362H296.218V402.703H312.58V382.362Z",
    fill: "#F5F5F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M339.759 382.362H321.814V402.703H339.759V382.362Z",
    fill: "#E6E6E6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M339.759 382.362H323.396V402.703H339.759V382.362Z",
    fill: "#F5F5F5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M285.387 443.338H267.442V463.679H285.387V443.338Z",
    fill: "#E6E6E6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M285.388 443.338H269.025V463.679H285.388V443.338Z",
    fill: "#F5F5F5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M312.581 443.338H294.636V463.679H312.581V443.338Z",
    fill: "#E6E6E6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M312.58 443.338H296.218V463.679H312.58V443.338Z",
    fill: "#F5F5F5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M339.759 443.338H321.814V463.679H339.759V443.338Z",
    fill: "#E6E6E6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M339.759 443.338H323.396V463.679H339.759V443.338Z",
    fill: "#F5F5F5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M285.387 473.304H267.442V493.644H285.387V473.304Z",
    fill: "#E6E6E6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M285.388 473.304H269.025V493.644H285.388V473.304Z",
    fill: "#F5F5F5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M312.581 473.304H294.636V493.644H312.581V473.304Z",
    fill: "#E6E6E6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M312.58 473.304H296.218V493.644H312.58V473.304Z",
    fill: "#F5F5F5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M339.759 473.304H321.814V493.644H339.759V473.304Z",
    fill: "#E6E6E6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M339.759 473.304H323.396V493.644H339.759V473.304Z",
    fill: "#F5F5F5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M375.181 332.182H258.374V334.069H375.181V332.182Z",
    fill: "#E0E0E0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M375.181 425.977H258.374V427.864H375.181V425.977Z",
    fill: "#E0E0E0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M238.653 314.281H157.859V510.877H238.653V314.281Z",
    fill: "#E0E0E0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M215.644 314.281H157.859V510.877H215.644V314.281Z",
    fill: "#F0F0F0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M185.314 330.437H163.805V340.881H185.314V330.437Z",
    fill: "#E6E6E6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M185.314 330.437H165.236V340.881H185.314V330.437Z",
    fill: "#F5F5F5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M210.195 330.437H188.686V340.881H210.195V330.437Z",
    fill: "#E6E6E6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M210.18 330.437H190.116V340.881H210.18V330.437Z",
    fill: "#F5F5F5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M185.314 350.088H163.805V360.533H185.314V350.088Z",
    fill: "#E6E6E6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M185.314 350.088H165.236V360.533H185.314V350.088Z",
    fill: "#F5F5F5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M210.195 350.088H188.686V360.533H210.195V350.088Z",
    fill: "#E6E6E6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M210.18 350.088H190.116V360.533H210.18V350.088Z",
    fill: "#F5F5F5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M185.314 375.203H163.805V385.648H185.314V375.203Z",
    fill: "#E6E6E6"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M185.314 375.203H165.236V385.648H185.314V375.203Z",
    fill: "#F5F5F5"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M210.195 375.203H188.686V385.648H210.195V375.203Z",
    fill: "#E6E6E6"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M210.18 375.203H190.116V385.648H210.18V375.203Z",
    fill: "#F5F5F5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M185.314 389.625H163.805V400.07H185.314V389.625Z",
    fill: "#E6E6E6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M185.314 389.625H165.236V400.07H185.314V389.625Z",
    fill: "#F5F5F5"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M210.195 389.625H188.686V400.07H210.195V389.625Z",
    fill: "#E6E6E6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M210.18 389.625H190.116V400.07H210.18V389.625Z",
    fill: "#F5F5F5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M185.314 413.336H163.805V423.781H185.314V413.336Z",
    fill: "#E6E6E6"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M185.314 413.336H165.236V423.781H185.314V413.336Z",
    fill: "#F5F5F5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M210.195 413.336H188.686V423.781H210.195V413.336Z",
    fill: "#E6E6E6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M210.18 413.336H190.116V423.781H210.18V413.336Z",
    fill: "#F5F5F5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M185.314 427.758H163.805V438.203H185.314V427.758Z",
    fill: "#E6E6E6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M185.314 427.758H165.236V438.203H185.314V427.758Z",
    fill: "#F5F5F5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M210.195 427.758H188.686V438.203H210.195V427.758Z",
    fill: "#E6E6E6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M210.18 427.758H190.116V438.203H210.18V427.758Z",
    fill: "#F5F5F5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M185.314 453.561H163.805V464.005H185.314V453.561Z",
    fill: "#E6E6E6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M185.314 453.561H165.236V464.005H185.314V453.561Z",
    fill: "#F5F5F5"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M210.195 453.561H188.686V464.005H210.195V453.561Z",
    fill: "#E6E6E6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M210.18 453.561H190.116V464.005H210.18V453.561Z",
    fill: "#F5F5F5"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M185.314 472.606H163.805V483.051H185.314V472.606Z",
    fill: "#E6E6E6"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M185.314 472.606H165.236V483.051H185.314V472.606Z",
    fill: "#F5F5F5"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M210.195 472.606H188.686V483.051H210.195V472.606Z",
    fill: "#E6E6E6"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M210.18 472.606H190.116V483.051H210.18V472.606Z",
    fill: "#F5F5F5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M238.653 366.96H157.859V368.763H238.653V366.96Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M238.653 405.795H157.859V407.598H238.653V405.795Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M238.653 444.974H157.859V446.763H238.653V444.974Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M238.639 308.46H154.048V314.735H238.639V308.46Z",
    fill: "#E0E0E0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M238.653 308.46H219.318V314.735H238.653V308.46Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M518.326 214.565H423.455V510.756H518.326V214.565Z",
    fill: "#E6E6E6"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M483.207 214.565H388.336V510.756H483.207V214.565Z",
    fill: "#F0F0F0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M474.937 234.668H396.621V249.761H474.937V234.668Z",
    fill: "#E6E6E6"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M474.924 234.668H399.648V249.761H474.924V234.668Z",
    fill: "#F5F5F5"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M474.937 260.076H396.621V275.169H474.937V260.076Z",
    fill: "#E6E6E6"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M474.924 260.076H399.648V275.169H474.924V260.076Z",
    fill: "#F5F5F5"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M474.937 286.46H396.621V301.553H474.937V286.46Z",
    fill: "#E6E6E6"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M474.924 286.46H399.648V301.553H474.924V286.46Z",
    fill: "#F5F5F5"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M474.937 312.86H396.621V327.953H474.937V312.86Z",
    fill: "#E6E6E6"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M474.924 312.86H399.648V327.953H474.924V312.86Z",
    fill: "#F5F5F5"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M474.937 339.244H396.621V354.337H474.937V339.244Z",
    fill: "#E6E6E6"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M474.924 339.244H399.648V354.337H474.924V339.244Z",
    fill: "#F5F5F5"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M474.937 365.645H396.621V380.738H474.937V365.645Z",
    fill: "#E6E6E6"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M474.924 365.645H399.648V380.738H474.924V365.645Z",
    fill: "#F5F5F5"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M474.937 394.723H396.621V409.816H474.937V394.723Z",
    fill: "#E6E6E6"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M474.924 394.723H399.648V409.816H474.924V394.723Z",
    fill: "#F5F5F5"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M474.937 423.818H396.621V438.911H474.937V423.818Z",
    fill: "#E6E6E6"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M474.924 423.818H399.648V438.911H474.924V423.818Z",
    fill: "#F5F5F5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M474.937 452.913H396.621V468.006H474.937V452.913Z",
    fill: "#E6E6E6"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M474.924 452.913H399.648V468.006H474.924V452.913Z",
    fill: "#F5F5F5"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M474.937 481.991H396.621V497.084H474.937V481.991Z",
    fill: "#E6E6E6"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M474.924 481.991H399.648V497.084H474.924V481.991Z",
    fill: "#F5F5F5"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M520.79 211.59H385.652V218.814H520.79V211.59Z",
    fill: "#E0E0E0"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M520.79 198.547H385.652V205.771H520.79V198.547Z",
    fill: "#E0E0E0"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M516.304 204.35H388.336V211.574H516.304V204.35Z",
    fill: "#F0F0F0"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M518.326 234.668H491.891V249.761H518.326V234.668Z",
    fill: "#E0E0E0"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M518.326 259.497H491.891V274.59H518.326V259.497Z",
    fill: "#E0E0E0"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M518.326 284.344H491.891V299.437H518.326V284.344Z",
    fill: "#E0E0E0"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M518.326 312.844H491.891V327.937H518.326V312.844Z",
    fill: "#E0E0E0"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M518.326 339.244H491.891V354.337H518.326V339.244Z",
    fill: "#E0E0E0"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M518.326 365.645H491.891V380.738H518.326V365.645Z",
    fill: "#E0E0E0"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M518.326 394.723H491.891V409.816H518.326V394.723Z",
    fill: "#E0E0E0"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M518.326 423.818H491.891V438.911H518.326V423.818Z",
    fill: "#E0E0E0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M518.326 452.896H491.891V467.989H518.326V452.896Z",
    fill: "#E0E0E0"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M518.326 481.991H491.891V497.084H518.326V481.991Z",
    fill: "#E0E0E0"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M618.044 401.006H610.434V412.909H618.044V401.006Z",
    fill: "#E0E0E0"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M618.044 420.492H610.434V432.396H618.044V420.492Z",
    fill: "#E0E0E0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M618.044 439.414H610.434V451.318H618.044V439.414Z",
    fill: "#E0E0E0"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M618.044 459.437H610.434V471.34H618.044V459.437Z",
    fill: "#E0E0E0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M618.044 478.909H610.434V490.813H618.044V478.909Z",
    fill: "#E0E0E0"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M618.044 389.047H537.994V510.794H618.044V389.047Z",
    fill: "#E6E6E6"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M604.531 389.047H538.008V510.794H604.531V389.047Z",
    fill: "#F0F0F0"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M598.09 401.006H543.994V412.909H598.09V401.006Z",
    fill: "#EBEBEB"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M598.09 420.492H543.994V432.396H598.09V420.492Z",
    fill: "#EBEBEB"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M598.09 439.964H543.994V451.868H598.09V439.964Z",
    fill: "#EBEBEB"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M598.09 459.437H543.994V471.34H598.09V459.437Z",
    fill: "#EBEBEB"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M598.09 478.909H543.994V490.813H598.09V478.909Z",
    fill: "#EBEBEB"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M598.077 401.006H545.977V412.909H598.077V401.006Z",
    fill: "#F5F5F5"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M598.077 420.492H545.977V432.396H598.077V420.492Z",
    fill: "#F5F5F5"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M598.077 439.964H545.977V451.868H598.077V439.964Z",
    fill: "#F5F5F5"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M598.077 459.437H545.977V471.34H598.077V459.437Z",
    fill: "#F5F5F5"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M598.077 478.909H545.977V490.813H598.077V478.909Z",
    fill: "#F5F5F5"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M482.099 513.017C470.51 502.853 421.029 460.115 406.625 459.002C392.516 457.873 342.429 501.101 328.876 513.017H482.099Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M673.133 513.018H687.34",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7578 513.018H658.926",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M0.660156 513.018H11.7087",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M644.538 419.604H602.062V479.184H619.658H644.538H662.15V449.394L644.538 419.604Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M662.149 479.185H642.688V492.721H662.149V479.185Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M570.487 478.513C570.487 478.513 591.766 467.055 584.4 409.766L557.392 395.035L510.743 387.669L469.004 389.306V413.04C469.004 413.04 492.738 433.5 495.193 440.047C496.733 444.528 497.561 449.223 497.648 453.96V476.876L570.487 478.513Z",
    fill: "#E0E0E0",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M584.401 409.767L570.488 478.513",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M557.394 395.035L541.844 478.513",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M510.743 387.669L499.285 449.868",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M470.641 409.767C470.641 409.767 497.648 421.224 508.288 428.59C518.927 435.956 517.29 451.506 517.29 451.506",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M602.438 479.609H475.535V490.249H602.438V479.609Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M627.777 452.324H654.278L640.054 427.771H627.777V452.324Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M623.684 427.771H612.227V452.324H623.684V427.771Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M553.465 479.185H476.207V497.632H553.465V479.185Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M626.654 512.718C635.488 511.123 641.356 502.668 639.76 493.834C638.164 485 629.709 479.133 620.876 480.729C612.042 482.325 606.175 490.779 607.77 499.613C609.366 508.447 617.821 514.314 626.654 512.718Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M623.733 506.257C628.967 506.257 633.21 502.014 633.21 496.78C633.21 491.546 628.967 487.303 623.733 487.303C618.499 487.303 614.256 491.546 614.256 496.78C614.256 502.014 618.499 506.257 623.733 506.257Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M501.383 512.753C510.222 511.188 516.119 502.754 514.554 493.915C512.989 485.076 504.555 479.179 495.716 480.744C486.876 482.309 480.98 490.743 482.545 499.582C484.109 508.421 492.544 514.318 501.383 512.753Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M498.516 506.257C503.75 506.257 507.993 502.014 507.993 496.78C507.993 491.546 503.75 487.303 498.516 487.303C493.282 487.303 489.039 491.546 489.039 496.78C489.039 502.014 493.282 506.257 498.516 506.257Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M548.754 508.682C555.366 502.611 555.804 492.329 549.732 485.717C543.661 479.105 533.379 478.667 526.767 484.738C520.155 490.81 519.717 501.091 525.788 507.703C531.86 514.315 542.142 514.753 548.754 508.682Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M537.751 506.257C542.985 506.257 547.228 502.014 547.228 496.78C547.228 491.546 542.985 487.303 537.751 487.303C532.517 487.303 528.273 491.546 528.273 496.78C528.273 502.014 532.517 506.257 537.751 506.257Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M532.432 450.688H491.511C488.573 450.688 486.191 453.069 486.191 456.007V473.194C486.191 476.132 488.573 478.514 491.511 478.514H532.432C535.37 478.514 537.751 476.132 537.751 473.194V456.007C537.751 453.069 535.37 450.688 532.432 450.688Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M465.73 478.513V397.572H482.099V478.513",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M465.846 408.293H481.919",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M465.846 420.93H481.919",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M465.846 433.566H481.919",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M465.846 446.219H481.919",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M465.846 458.854H481.919",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M465.846 471.491H481.919",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M138.35 514.605H108.887V0.642578L138.35 34.9013V514.605Z",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M109.182 406.574H138.072L109.182 378.634H138.072L109.182 406.574Z",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M109.182 377.93H138.072L109.182 349.989H138.072L109.182 377.93Z",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M109.182 349.286H138.072L109.182 321.346H138.072L109.182 349.286Z",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M109.182 320.642H138.072L109.182 292.701H138.072L109.182 320.642Z",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M109.182 291.997H138.072L109.182 264.057H138.072L109.182 291.997Z",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M109.182 263.353H138.072L109.182 235.412H138.072L109.182 263.353Z",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M109.182 234.708H138.072L109.182 206.768H138.072L109.182 234.708Z",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M109.182 206.064H138.072L109.182 178.123H138.072L109.182 206.064Z",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M109.182 177.419H138.072L109.182 149.479H138.072L109.182 177.419Z",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M109.182 148.775H138.072L109.182 120.835H138.072L109.182 148.775Z",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M109.182 120.131H138.072L109.182 92.1904H138.072L109.182 120.131Z",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M109.182 91.4865H138.072L109.182 63.5459H138.072L109.182 91.4865Z",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M109.182 62.8419H138.072L109.182 34.9014H138.072L109.182 62.8419Z",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M275.139 63.6111L260.866 54.625H159.006L146.566 63.6111H275.139Z",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M277.496 62.8418H28.6992V69.3891H277.496V62.8418Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M260.866 54.625L108.887 0.642578L159.006 54.625",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M108.904 0.642578L28.6992 62.8418",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M159.645 76.7549H98.2637V116.039H159.645V76.7549Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M146.846 84.9385H111.049V96.3963H146.846V84.9385Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M277.496 69.3887V139.968",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M265.191 173.793L277.316 139.945L358.147 155.636",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M228.44 412.762L267.724 474.863L277.545 467.678L248.639 409.865C247.34 407.266 245.342 405.081 242.87 403.554C240.398 402.028 237.549 401.22 234.644 401.223C233.31 401.247 232.007 401.626 230.869 402.321C229.73 403.016 228.797 404.002 228.165 405.177C227.534 406.352 227.226 407.674 227.274 409.007C227.323 410.34 227.725 411.636 228.44 412.762Z",
    fill: "#E0E0E0",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M274.091 459.592L233.678 488.334C233.678 488.334 237.279 503.59 260.62 502.689C283.961 501.789 283.077 477.548 283.077 477.548L274.091 459.592Z",
    fill: "#2E353A",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M161.838 440.735L235.037 407.753C237.451 406.667 240.164 406.44 242.725 407.11C245.286 407.78 247.54 409.306 249.113 411.436C250.032 412.679 250.693 414.094 251.056 415.597C251.419 417.1 251.477 418.661 251.227 420.187C250.976 421.712 250.423 423.173 249.599 424.481C248.775 425.789 247.697 426.919 246.429 427.804L166.339 483.865L161.838 440.735Z",
    fill: "#E0E0E0",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M151.068 481.148H75.627V492.819H151.068V481.148Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M114.24 447.921H48.6855V474.863H114.24V447.921Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M105.712 417.378H161.364C162.666 417.378 163.915 417.895 164.836 418.816C165.757 419.737 166.274 420.986 166.274 422.288V474.83H100.785V422.288C100.785 421.642 100.913 421.002 101.16 420.405C101.408 419.809 101.771 419.267 102.229 418.81C102.687 418.354 103.23 417.993 103.828 417.747C104.425 417.501 105.066 417.376 105.712 417.378Z",
    fill: "#E0E0E0",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0141 513.017H155.341C158.731 513.017 161.982 511.67 164.38 509.273C166.777 506.876 168.124 503.624 168.124 500.234C168.124 496.842 166.778 493.588 164.381 491.188C161.984 488.788 158.732 487.438 155.341 487.434H48.0141C44.6221 487.438 41.3706 488.788 38.9737 491.188C36.5768 493.588 35.2305 496.842 35.2305 500.234C35.2305 503.624 36.5773 506.876 38.9747 509.273C41.3721 511.67 44.6236 513.017 48.0141 513.017Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1867 513.017H171.497C174.889 513.017 178.142 511.671 180.542 509.274C182.942 506.877 184.292 503.625 184.297 500.234C184.297 496.839 182.948 493.583 180.548 491.183C178.147 488.782 174.892 487.434 171.497 487.434H64.1867C60.7919 487.434 57.5362 488.782 55.1357 491.183C52.7353 493.583 51.3867 496.839 51.3867 500.234C51.3911 503.625 52.7415 506.877 55.1415 509.274C57.5415 511.671 60.7947 513.017 64.1867 513.017Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M166.324 474.863H48.6855V483.85H166.324V474.863Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9433 500.233C72.9433 501.833 72.4691 503.396 71.5806 504.726C70.6921 506.055 69.4292 507.092 67.9517 507.704C66.4742 508.316 64.8484 508.476 63.2799 508.164C61.7114 507.852 60.2706 507.082 59.1398 505.951C58.009 504.82 57.2389 503.379 56.9269 501.811C56.6149 500.242 56.775 498.617 57.387 497.139C57.999 495.662 59.0354 494.399 60.3651 493.51C61.6948 492.622 63.2582 492.147 64.8574 492.147C67.0019 492.147 69.0586 492.999 70.575 494.516C72.0914 496.032 72.9433 498.089 72.9433 500.233Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M86.414 508.319C90.8797 508.319 94.4999 504.699 94.4999 500.233C94.4999 495.768 90.8797 492.147 86.414 492.147C81.9483 492.147 78.3281 495.768 78.3281 500.233C78.3281 504.699 81.9483 508.319 86.414 508.319Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M107.955 508.319C112.421 508.319 116.041 504.699 116.041 500.233C116.041 495.768 112.421 492.147 107.955 492.147C103.489 492.147 99.8691 495.768 99.8691 500.233C99.8691 504.699 103.489 508.319 107.955 508.319Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M137.598 500.233C137.598 501.833 137.123 503.396 136.235 504.726C135.346 506.055 134.084 507.092 132.606 507.704C131.129 508.316 129.503 508.476 127.934 508.164C126.366 507.852 124.925 507.082 123.794 505.951C122.663 504.82 121.893 503.379 121.581 501.811C121.269 500.242 121.429 498.617 122.041 497.139C122.653 495.662 123.69 494.399 125.019 493.51C126.349 492.622 127.912 492.147 129.512 492.147C131.656 492.147 133.713 492.999 135.229 494.516C136.746 496.032 137.598 498.089 137.598 500.233Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M159.154 500.233C159.154 501.833 158.68 503.396 157.792 504.726C156.903 506.055 155.64 507.092 154.163 507.704C152.685 508.316 151.059 508.476 149.491 508.164C147.922 507.852 146.482 507.082 145.351 505.951C144.22 504.82 143.45 503.379 143.138 501.811C142.826 500.242 142.986 498.617 143.598 497.139C144.21 495.662 145.246 494.399 146.576 493.51C147.906 492.622 149.469 492.147 151.068 492.147C153.213 492.147 155.27 492.999 156.786 494.516C158.302 496.032 159.154 498.089 159.154 500.233Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M180.695 500.233C180.695 501.833 180.221 503.397 179.331 504.727C178.442 506.057 177.178 507.094 175.7 507.705C174.221 508.317 172.595 508.476 171.026 508.163C169.457 507.849 168.016 507.078 166.886 505.945C165.756 504.813 164.987 503.37 164.677 501.801C164.367 500.231 164.529 498.605 165.144 497.128C165.758 495.65 166.797 494.389 168.129 493.502C169.461 492.616 171.026 492.144 172.626 492.147C173.687 492.147 174.737 492.357 175.718 492.763C176.698 493.17 177.588 493.766 178.338 494.517C179.087 495.268 179.681 496.159 180.086 497.14C180.49 498.121 180.697 499.172 180.695 500.233Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M243.565 417.378C243.565 416.487 243.301 415.616 242.805 414.876C242.31 414.135 241.606 413.558 240.783 413.218C239.959 412.878 239.053 412.79 238.18 412.965C237.306 413.14 236.504 413.57 235.875 414.201C235.246 414.832 234.819 415.636 234.647 416.51C234.475 417.384 234.567 418.29 234.91 419.112C235.253 419.934 235.833 420.636 236.575 421.129C237.317 421.621 238.189 421.883 239.08 421.879C239.67 421.879 240.255 421.763 240.8 421.537C241.345 421.31 241.841 420.978 242.257 420.56C242.674 420.142 243.004 419.646 243.228 419.1C243.453 418.554 243.567 417.969 243.565 417.378Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M156.452 424.563H108.854V453.306H156.452V424.563Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M156.454 424.563H130.412V453.306H156.454V424.563Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M358.277 155.222L265.168 173.962L273.142 213.583L366.251 194.843L358.277 155.222Z",
    fill: "#07839C",
    stroke: "#07839C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M295.276 191.657L293.985 185.579C293.98 185.559 293.968 185.551 293.949 185.555C293.909 185.564 293.892 185.578 293.896 185.598L290.896 192.774L290.873 192.81L290.879 192.839C290.883 192.859 290.895 192.867 290.915 192.863L295.066 191.981C295.244 191.943 295.314 191.835 295.276 191.657ZM302.241 190.456C302.696 190.359 303.127 190.443 303.534 190.708C303.942 190.973 304.194 191.332 304.29 191.787L304.549 193.002C304.645 193.457 304.561 193.888 304.297 194.296C304.032 194.703 303.672 194.955 303.218 195.052L302.18 195.272C302.022 195.306 301.962 195.411 301.999 195.589L302.403 197.487C302.499 197.942 302.415 198.373 302.151 198.78C301.886 199.187 301.526 199.439 301.072 199.536L298.818 200.015C298.364 200.111 297.933 200.027 297.525 199.763C297.118 199.498 296.866 199.139 296.769 198.684L296.366 196.786C296.328 196.608 296.22 196.538 296.043 196.576L288.512 198.176C288.057 198.273 287.626 198.189 287.218 197.924C286.811 197.66 286.559 197.3 286.462 196.845L286.204 195.63C285.969 194.523 286.079 193.436 286.534 192.368L291.841 180.302C292.3 179.254 293.093 178.61 294.219 178.371L296.473 177.892C296.927 177.795 297.358 177.879 297.766 178.144C298.173 178.409 298.425 178.768 298.522 179.223L300.91 190.46C300.947 190.638 301.045 190.71 301.203 190.676L302.241 190.456Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M315.33 190.681C315.986 191.533 316.808 191.854 317.796 191.644C318.785 191.434 319.396 190.808 319.629 189.767C319.878 188.702 319.733 186.905 319.196 184.374C318.658 181.844 318.061 180.153 317.405 179.301C316.764 178.425 315.95 178.092 314.961 178.302C313.973 178.512 313.355 179.149 313.106 180.214C312.872 181.256 313.025 183.041 313.562 185.571C314.1 188.101 314.689 189.805 315.33 190.681ZM307.87 177.887C308.963 175.837 311.012 174.493 314.016 173.854C317.021 173.216 319.439 173.611 321.272 175.04C323.104 176.468 324.438 179.149 325.274 183.083C326.11 187.016 325.981 190.008 324.888 192.059C323.795 194.109 321.746 195.453 318.741 196.092C315.737 196.73 313.318 196.335 311.486 194.906C309.654 193.477 308.32 190.796 307.484 186.863C306.648 182.929 306.777 179.937 307.87 177.887Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M338.376 182.499L337.085 176.421C337.081 176.401 337.069 176.393 337.049 176.398C337.009 176.406 336.992 176.42 336.996 176.44L333.996 183.616L333.973 183.652L333.979 183.681C333.983 183.701 333.995 183.709 334.015 183.705L338.166 182.823C338.344 182.785 338.414 182.677 338.376 182.499ZM345.341 181.298C345.796 181.201 346.227 181.285 346.634 181.55C347.042 181.815 347.294 182.174 347.39 182.629L347.649 183.845C347.745 184.299 347.661 184.73 347.397 185.138C347.132 185.545 346.772 185.797 346.318 185.894L345.28 186.114C345.122 186.148 345.062 186.254 345.1 186.431L345.503 188.329C345.599 188.784 345.515 189.215 345.251 189.622C344.986 190.03 344.626 190.282 344.172 190.378L341.918 190.857C341.464 190.954 341.033 190.87 340.625 190.605C340.218 190.34 339.966 189.981 339.869 189.526L339.466 187.628C339.428 187.451 339.32 187.381 339.143 187.418L331.612 189.018C331.157 189.115 330.726 189.031 330.318 188.766C329.911 188.502 329.659 188.142 329.562 187.688L329.304 186.472C329.069 185.365 329.179 184.278 329.634 183.21L334.941 171.144C335.4 170.096 336.193 169.452 337.319 169.213L339.573 168.734C340.027 168.637 340.458 168.721 340.866 168.986C341.273 169.251 341.525 169.61 341.622 170.065L344.01 181.302C344.047 181.48 344.145 181.552 344.304 181.519L345.341 181.298Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.cc182b9100bd8766d9665c088022a2bf.svg";
export { ForwardRef as ReactComponent };